/**
 * A document figure in the currency the picker is SHOWING — and a typed figure back.
 *
 * The quotation's currency picker is a view: it writes nothing, and the totals panel converts
 * every figure for it. The discount and tax editors hold the document's own figures — what a
 * commit writes — so they used to label them with the view currency unconverted ("133 AED" as
 * "$133"), then say so instead. Akhil, 2026-09-17: convert them like the line items and the
 * commission. `toView` rounds to the cent for display; `fromView` keeps full precision so a
 * typed figure round-trips to itself rather than drifting a cent per keystroke. No rate on
 * file: the figures stay in the document's currency, labelled as such (`missingRate`).
 */
import { fxLookup, type WireFx } from './api/wire'
import type { Currency } from './types'

const round2 = (n: number) => Math.round(n * 100) / 100

export function viewMoney(documentCurrency: Currency, displayCurrency: Currency, fx: WireFx): {
  currency: Currency
  missingRate: boolean
  toView: (documentAmount: number) => number
  fromView: (viewAmount: number) => number
} {
  if (documentCurrency === displayCurrency) return { currency: documentCurrency, missingRate: false, toView: (n) => n, fromView: (n) => n }
  const rate = fxLookup(fx, documentCurrency, displayCurrency)
  if (rate === null) return { currency: documentCurrency, missingRate: true, toView: (n) => n, fromView: (n) => n }
  return { currency: displayCurrency, missingRate: false, toView: (n) => round2(n * rate), fromView: (n) => n / rate }
}
